<template>
  <div class="vue-modal-dialog-mask white-modal" :class="$style.modal">
    <div class="vue-modal-dialog-content">
      <header>
        Share with your team
        <button
          type="button"
          @click="$close(true)"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
        >
          <font-awesome-icon :icon="faTimes" />
        </button>
      </header>
      <div>
        <div :class="$style.formGroup">
          <multiselect
            v-model="selectedTeammates"
            label="text"
            track-by="id"
            placeholder="Teammate"
            open-direction="bottom"
            :allow-empty="true"
            :show-labels="false"
            :options="teammates"
            :multiple="true"
          >
            <template #noResult>
              <span>No matches found</span>
            </template>
          </multiselect>
          <span :class="$style.error" v-show="errors.has('teammate')">{{
            errors.first("teammate")
          }}</span>
        </div>
        <div :class="$style.formGroup">
          <textarea
            v-model="note"
            v-validate:note="'required'"
            name="note"
            rows="5"
            placeholder="Tell your team what they will learn from listening to this activity"
            autocomplete="note-share-activity"
            :class="$style.note"
          ></textarea>
          <span :class="$style.error" v-show="errors.has('note')">{{
            errors.first("note")
          }}</span>
        </div>
        <span
          :class="$style.error"
          v-show="errors.has('service_unavailable')"
          >{{ errors.first("service_unavailable") }}</span
        >
        <div :class="$style.formGroup">
          <div
            v-if="notificationProvider"
            :class="[$style.postToProvider, $style.formGroup]"
          >
            <div :class="$style.providerItem">
              <svg
                width="28px"
                height="28px"
                viewBox="0 0 55 55"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                preserveAspectRatio="xMinYMin"
              >
                <g>
                  <path
                    d="M19.712.133a5.381 5.381 0 0 0-5.376 5.387 5.381 5.381 0 0 0 5.376 5.386h5.376V5.52A5.381 5.381 0 0 0 19.712.133m0 14.365H5.376A5.381 5.381 0 0 0 0 19.884a5.381 5.381 0 0 0 5.376 5.387h14.336a5.381 5.381 0 0 0 5.376-5.387 5.381 5.381 0 0 0-5.376-5.386"
                    fill="#36C5F0"
                  ></path>
                  <path
                    d="M53.76 19.884a5.381 5.381 0 0 0-5.376-5.386 5.381 5.381 0 0 0-5.376 5.386v5.387h5.376a5.381 5.381 0 0 0 5.376-5.387m-14.336 0V5.52A5.381 5.381 0 0 0 34.048.133a5.381 5.381 0 0 0-5.376 5.387v14.364a5.381 5.381 0 0 0 5.376 5.387 5.381 5.381 0 0 0 5.376-5.387"
                    fill="#2EB67D"
                  ></path>
                  <path
                    d="M34.048 54a5.381 5.381 0 0 0 5.376-5.387 5.381 5.381 0 0 0-5.376-5.386h-5.376v5.386A5.381 5.381 0 0 0 34.048 54m0-14.365h14.336a5.381 5.381 0 0 0 5.376-5.386 5.381 5.381 0 0 0-5.376-5.387H34.048a5.381 5.381 0 0 0-5.376 5.387 5.381 5.381 0 0 0 5.376 5.386"
                    fill="#ECB22E"
                  ></path>
                  <path
                    d="M0 34.249a5.381 5.381 0 0 0 5.376 5.386 5.381 5.381 0 0 0 5.376-5.386v-5.387H5.376A5.381 5.381 0 0 0 0 34.25m14.336-.001v14.364A5.381 5.381 0 0 0 19.712 54a5.381 5.381 0 0 0 5.376-5.387V34.25a5.381 5.381 0 0 0-5.376-5.387 5.381 5.381 0 0 0-5.376 5.387"
                    fill="#E01E5A"
                  ></path>
                </g>
              </svg>
              <span :class="[$style.providerText, $style.providerLabel]"
                >Send activity to
              </span>
              <toggle-button
                v-model="postToProvider"
                @change="onpostToProviderChange"
                color="#24f7db"
              ></toggle-button>
            </div>
            <div :class="$style.providerItem">
              <span
                :class="$style.providerChannels"
                v-show="showProviderChannels || !selectedProviderChannelName"
              >
                <multiselect
                  name="providerChannel"
                  v-model="selectedProviderChannel"
                  label="name"
                  track-by="id"
                  placeholder="Channel"
                  open-direction="bottom"
                  :allow-empty="false"
                  :show-labels="false"
                  :options="providerChannels"
                  group-values="channels"
                  group-label="name"
                  @input="onSelectProviderChannel"
                >
                  <template #noResult>
                    <span>No matches found</span>
                  </template>
                </multiselect>
              </span>
              <button
                v-if="postToProvider"
                v-show="!showProviderChannels && selectedProviderChannelName"
                @click="showProviderChannels = true"
                :class="[$style.providerText, $style.showProviderChannels]"
              >
                {{ selectedProviderChannelName }}
              </button>
              <span
                :class="[$style.providerText, $style.providerChannelName]"
                v-else
                >{{ selectedProviderChannelName }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <footer>
        <button :class="$style.save" :disabled="busy" @click="shareActivity">
          {{ buttonLabel }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-components/vue-multiselect";
import { createNamespacedHelpers } from "vuex";
import { successNotification, errorNotification } from "../../notifications";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";

const { mapState } = createNamespacedHelpers("activitySummary");

export default {
  components: {
    Multiselect,
    FontAwesomeIcon,
  },
  data() {
    return {
      busy: false,
      selectedTeammates: [],
      note: "",
      buttonLabel: "Share",
      timeStart: 0,
      timeEnd: null,
      canpostToProvider: false,
      postToProvider: true,
      showProviderChannels: false,
      defaultChannelId: null,
      selectedProviderChannel: null,
      selectedProviderChannelName: "",
      teammates: [],
      providerChannels: [],
      faTimes,
    };
  },
  computed: {
    ...mapState(["activity"]),
    getParticipantsUrl() {
      return `${this.$_activitySummary_config.jiminnyHost()}/api/v1/organizations/${
        this.$_activitySummary_config.getTeam().id
      }/slugs`;
    },
    notificationProvider() {
      return this.$_activitySummary_config.getTeam().notificationProvider;
    },
    getChannelsUrl() {
      return `${this.$_activitySummary_config.jiminnyHost()}/api/v1/${
        this.notificationProvider
      }/channels`;
    },
    shareActivityUrl() {
      return `${this.$_activitySummary_config.jiminnyHost()}/api/v1/activity/${
        this.activity.id
      }/share`;
    },
    trimmedNote() {
      return this.note.trim();
    },
    selectedProviderChannelId() {
      return this.selectedProviderChannel
        ? this.selectedProviderChannel.id
        : null;
    },
  },
  watch: {
    selectedTeammates() {
      this.errors.remove("teammate");
    },
    postToProvider(val) {
      if (!val) {
        this.errors.remove("providerChannel");
        this.showProviderChannels = false;
      }
    },
  },
  created() {
    this.setupRecipients();
    this.setupProviderChannels();
  },
  methods: {
    onSelectProviderChannel(providerChannel) {
      this.selectedProviderChannelName = providerChannel.name;
      this.showProviderChannels = false;
    },
    setupRecipients() {
      axios.get(this.getParticipantsUrl).then((response) => {
        this.teammates = response.data.map((recipient) => ({
          id: `${recipient.type}_____${recipient.id}`,
          text: recipient.name,
        }));
      });
    },
    async setupProviderChannels() {
      try {
        const response = await axios.get(this.getChannelsUrl);

        const { groups, default: defaultChannelId } = response.data;
        let defaultChannel = {};

        if (defaultChannelId) {
          for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            const match = group.channels.find(
              (channel) => channel.id === defaultChannelId
            );

            if (match) {
              defaultChannel = match;
              this.postToProvider = true;
              break;
            }
          }
        }

        this.providerChannels = groups;

        this.canpostToProvider = true;
        this.defaultChannelId = defaultChannel.id || null;

        console.log(123, defaultChannel);
        console.log(356, this.providerChannels);

        this.selectedProviderChannel = defaultChannel;
        this.selectedProviderChannelName = defaultChannel
          ? defaultChannel.name
          : null;
      } catch (error) {
        console.error(error);
        const errors = error.response;

        if (errors && errors.status === 503) {
          this.errors.add(
            "service_unavailable",
            errors.data.service_unavailable
          );
        }
      }
    },
    closeModal() {
      this.$close(true);
    },
    onpostToProviderChange() {
      if (this.canpostToProvider && this.postToProvider) {
        this.errors.remove("teammate");
      }
    },
    shareActivity() {
      if (this.selectedTeammates.length === 0) {
        if (!this.canpostToProvider || !this.postToProvider) {
          return this.errors.add("teammate", "The teammate field is required.");
        }
      }

      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }

        const payload = {
          note: this.trimmedNote,
          start_time: this.timeStart,
          end_time: this.timeEnd,
          recipients: this.selectedTeammates.map((item) => {
            const [type, id] = item.id.split("_____");
            return { type, id };
          }),
          ...(this.canpostToProvider &&
            this.postToProvider && { share: this.selectedProviderChannelId }),
        };

        this.busy = true;
        axios
          .post(this.shareActivityUrl, payload)
          .then(() => {
            this.busy = false;
            this.closeModal();
            this.selectedTeammates = [];
            this.selectedProviderChannel = null;
            this.note = "";
            this.$nextTick(() => this.errors.clear());
            successNotification({
              message: "Success! Your activity has been shared.",
            }).show();
          })
          .catch((error) => {
            this.busy = false;
            this.handleErrors(error.response);
          });
      });
    },
    handleErrors(response) {
      const errors = response.data;

      if (response.status === 403) {
        errorNotification({
          message: "You are not authorized to perform this action.",
        }).show();
        this.closeModal();
      } else if (errors.hasOwnProperty("errors")) {
        Object.keys(errors.errors).forEach((key) => {
          this.errors.add(key, errors.errors[key][0]);
        });
      } else {
        errorNotification({
          message: "Something went wrong. Please try again later.",
        }).show();
        this.closeModal();
      }
    },
  },
};
</script>

<style module lang="less" src="./share-activity-modal.less"></style>



// WEBPACK FOOTER //
// share-activity-modal.vue?4548b84e